import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderContainer = styled.header`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: saturate(140%) blur(10px);
  -webkit-backdrop-filter: saturate(140%) blur(10px);
  box-shadow: 0 1px 0 var(--color-border), 0 6px 18px rgba(26, 31, 21, 0.04);
`;

export const StyledFragment = styled.div`
    @media (max-width: 900px) {
        display: none;
    }
`;

export const UpBlock = styled.div`
  width: min(92%, 1400px);
  margin: 0 auto;
  padding: 14px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid var(--color-border);

  > div:nth-child(2) {
    flex: 1;
    justify-content: center;
    gap: 32px;
  }
`;

export const BottomBlock = styled.div`
  width: min(92%, 1400px);
  margin: 0 auto;
  display: flex;
  gap: 4px;
  padding: 6px 0 0;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const HeaderBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
    @media (max-width: 900px) {
        align-items: center;
    }
`;

export const LogoImg = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;

    @media (max-width: 900px) {
        width: 44px;
        height: 44px;
    }
`;

export const MiniImg = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  flex-shrink: 0;
`;

export const ContactBlock = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 240px;
  color: var(--color-text-muted);
  font-size: 13px;
  line-height: 1.45;
`;

export const Text = styled.p`
  line-height: 1.4;
  margin: 0;
  font-size: 13px;
  color: var(--color-text);
  text-align: left;

  & + & {
    margin-top: 1px;
  }
`;

export const ContactImgBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: var(--color-primary-soft);
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;

  img {
    margin-right: 0;
    width: 16px;
    height: 16px;
  }
`;

export const ContactImgBlockSocial = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  background: var(--color-primary-soft);
  border-radius: 50%;
  cursor: pointer;
  margin-right: 8px;
  transition: var(--transition);

  &:hover {
    background: var(--color-primary);
  }

  img {
    margin-right: 0;
    width: 18px;
    height: 18px;
  }
`;

export const ContactTextBlock = styled.div`
  font-size: 13px;
  color: var(--color-text);
`;

export const AppointmentButton = styled.button`
  background: var(--color-primary);
  padding: 12px 22px;
  border-radius: var(--radius-md);
  border: none;
  cursor: pointer;
  color: white;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.3px;
  transition: var(--transition);
  box-shadow: 0 6px 14px rgba(91, 139, 15, 0.25);

  &:hover {
    background: var(--color-primary-dark);
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(91, 139, 15, 0.32);
  }
`;

interface ToggleBlockProps {
  backgroundColor?: boolean;
}

export const LinkBlock = styled.div<ToggleBlockProps>`
    text-decoration: none;
    cursor: pointer;
    position: relative;
    background: ${({ backgroundColor }) => (backgroundColor ? 'var(--color-primary)' : 'transparent')};
    height: 44px;
    display: flex;
    align-items: stretch;
    border-radius: var(--radius-md) var(--radius-md) ${({ backgroundColor }) => (backgroundColor ? '0 0' : 'var(--radius-md) var(--radius-md)')};
    transition: var(--transition);

    &:hover {
        background: ${({ backgroundColor }) => (backgroundColor ? 'var(--color-primary)' : 'var(--color-primary-soft)')};
    }

    a {
        display: flex;
        align-items: center;
        padding: 0 14px;
        text-decoration: none;
        color: ${({ backgroundColor }) => (backgroundColor ? 'white' : 'var(--color-text)')};
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.3px;
        white-space: nowrap;
    }
`;

export const ToggleBlock = styled.div`
    position: absolute;
    top: 44px;
    left: 0;
    background: white;
    z-index: 9;
    border-radius: 0 var(--radius-md) var(--radius-md) var(--radius-md);
    width: max-content;
    min-width: 240px;
    padding: 8px 0;
    box-shadow: var(--shadow-lg);
    border: 1px solid var(--color-border);
`;

export const ToggleText = styled.p`
    font-size: 14px;
    margin: 0;
    transition: var(--transition);

    a {
        display: block;
        padding: 10px 16px;
        color: var(--color-text) !important;
        font-weight: 500 !important;
        cursor: pointer;
        transition: var(--transition);
    }

    &:hover a {
        background: var(--color-primary-soft);
        color: var(--color-primary) !important;
    }
`;

export const MobileContainer = styled.div`
    display: none;
    height: 68px;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    position: relative;
    @media (max-width: 900px) {
        display: flex;
    }

    > div:first-child {
        gap: 12px;
        min-width: 0;
        flex: 1;
    }
`;

export const MobileLogoWrap = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border-radius: 14px;
    background: var(--color-primary-soft);
    flex-shrink: 0;
    transition: var(--transition);

    img {
        width: 34px;
        height: 34px;
        object-fit: contain;
    }

    &:hover, &:active {
        background: var(--color-primary);
    }
`;

export const MobileBrandInline = styled.div`
    display: flex;
    flex-direction: column;
    line-height: 1.15;
    min-width: 0;

    strong {
        font-size: 16px;
        font-weight: 800;
        color: var(--color-primary-dark);
        letter-spacing: 0.2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    span {
        font-size: 11px;
        font-weight: 500;
        color: var(--color-text-muted);
        letter-spacing: 0.3px;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const MobileBlockOpen = styled.button`
    width: 46px;
    height: 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    border: 1px solid var(--color-primary-light);
    border-radius: 14px;
    background: white;
    flex-shrink: 0;
    padding: 0;
    box-shadow: 0 4px 12px rgba(91, 139, 15, 0.12);
    transition: var(--transition);

    &:hover, &:active {
        background: var(--color-primary);
        border-color: var(--color-primary);
        box-shadow: 0 6px 16px rgba(91, 139, 15, 0.28);

        > div {
            background: white;
        }
    }
`;

export const MobileArrow = styled.div`
    width: 20px;
    height: 2px;
    background: var(--color-primary);
    border-radius: 2px;
    transition: var(--transition);
`;

export const MobilePopUp = styled.div`
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    background: linear-gradient(165deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);
    z-index: 99999;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    padding: 0 0 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    animation: mobileFadeIn 220ms ease;

    @keyframes mobileFadeIn {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
    }

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image: radial-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px);
        background-size: 22px 22px;
        pointer-events: none;
    }
`;

export const MobileTopBar = styled.div`
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 22px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.08), transparent);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
`;

export const MobileBrand = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const MobileBrandLogo = styled.img`
    width: 46px;
    height: 46px;
    background: white;
    border-radius: 50%;
    padding: 5px;
    flex-shrink: 0;
`;

export const MobileBrandText = styled.div`
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    color: white;
    min-width: 0;

    strong {
        font-size: 16px;
        font-weight: 800;
        letter-spacing: 0.2px;
    }

    span {
        font-size: 12px;
        opacity: 0.75;
        font-weight: 500;
    }
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.16);
    border: none;
    cursor: pointer;
    color: white;
    flex-shrink: 0;
    transition: var(--transition);
    padding: 0;

    svg {
        width: 18px;
        height: 18px;
    }

    &:hover, &:active {
        background: rgba(255, 255, 255, 0.28);
        transform: rotate(90deg);
    }
`;

export const MobileLinksContainer = styled.nav`
    position: relative;
    z-index: 1;
    padding: 0 18px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const MobileNavLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 18px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: var(--radius-md);
    text-decoration: none;
    transition: var(--transition);

    span {
        color: white;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 0.6px;
        text-transform: uppercase;
    }

    svg {
        width: 14px;
        height: 10px;
        color: white;
        opacity: 0.7;
        transition: transform var(--transition);
    }

    &:hover, &:active {
        background: rgba(255, 255, 255, 0.18);
        border-color: rgba(255, 255, 255, 0.28);

        svg {
            transform: translateX(3px);
            opacity: 1;
        }
    }
`;

export const MobileGroup = styled.div`
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: var(--radius-md);
    overflow: hidden;
`;

export const MobileGroupLabel = styled.div`
    padding: 12px 18px 6px;
    color: white;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    opacity: 0.85;
`;

export const MobileGroupList = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 10px 10px;
    gap: 2px;
`;

export const MobileGroupItem = styled(Link)`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: var(--radius-sm);
    color: white;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: var(--transition);

    &::before {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: white;
        opacity: 0.55;
        flex-shrink: 0;
    }

    &:hover, &:active {
        background: rgba(255, 255, 255, 0.16);

        &::before {
            opacity: 1;
        }
    }
`;

export const MobileCTAWrap = styled.div`
    position: relative;
    z-index: 1;
    padding: 0 18px;
`;

export const MobileCTA = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 16px 20px;
    background: white;
    color: var(--color-primary-dark);
    border-radius: var(--radius-md);
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    text-decoration: none;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
    transition: var(--transition);

    svg {
        width: 14px;
        height: 10px;
    }

    &:hover, &:active {
        transform: translateY(-2px);
        box-shadow: 0 14px 32px rgba(0, 0, 0, 0.24);
    }
`;

export const MobileContactSection = styled.div`
    position: relative;
    z-index: 1;
    padding: 18px 24px 4px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    color: white;

    &::before {
        content: "Контакты";
        align-self: center;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 2px;
        text-transform: uppercase;
        opacity: 0.7;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.18);
        width: 100%;
        text-align: center;
    }
`;

export const MobileContactRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 14px;
    line-height: 1.5;

    a {
        color: white;
        text-decoration: none;
        font-weight: 500;
        display: block;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const MobileContactIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    flex-shrink: 0;

    img {
        width: 14px;
        height: 14px;
    }
`;

export const MobileContactColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const MobileSocialRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 8px;

    a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.18);
        transition: var(--transition);

        &:hover, &:active {
            background: white;
            transform: translateY(-2px);
        }

        img {
            width: 18px;
            height: 18px;
        }
    }
`;

